import moment from "moment";
import "moment/locale/es";
import { round2Decimals } from "../Components/Items";

moment.locale("es");

const reporteCostoTotalProyectoPdf = (values) => {
  const { empresa, logoBiwo, resumen, detalleBajas, proyectos, filtrarProyecto, unidadDeNegocio } = values;

  /* =========================
     FILTROS
  ========================== */
  let filtrados = [];

  if (filtrarProyecto === 1 && proyectos?.length) {
    let textoFiltrado = "";
    proyectos.forEach(p => {
      textoFiltrado += `${p.nombre}\n`;
    });

    filtrados.push([
      { text: "Proyectos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (filtrarProyecto === 2 && unidadDeNegocio) {
    filtrados.push([
      { text: "Unidad de Negocio:", style: "subheader" },
      { text: unidadDeNegocio.nombre, style: "textoChico" },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  /* =========================
     RESUMEN DE COSTOS
  ========================== */
  const totalCompras = resumen.compras.reduce((a, b) => a + b.totalCompras, 0);
  const totalSalidas = resumen.salidas.reduce((a, b) => a + b.totalSalidas, 0);
  const totalProduccion = resumen.produccion || 0;
  const totalBajas = detalleBajas.reduce((a, b) => a + b.total, 0);

  const costoTotalProyecto =
    totalCompras + totalSalidas + totalProduccion + totalBajas;

  const resumenTabla = [
    ["Compras", totalCompras],
    ["Salidas de inventario", totalSalidas],
    ["Producción", totalProduccion],
    ["Bajas de inventario", totalBajas],
    ["TOTAL DEL PROYECTO", costoTotalProyecto],
  ].map(r => ([
    { text: r[0], style: "textoTabla" },
    { text: round2Decimals(r[1]).toFixed(2), style: "textoTabla", alignment: "right" },
  ]));

  /* =========================
     DETALLE BAJAS
  ========================== */
  const detalleTabla = detalleBajas.map(b => ([
    { text: b.proyecto || "", style: "textoTabla" },
    { text: b.insumo, style: "textoTabla" },
    { text: b.concepto, style: "textoTabla" },
    { text: round2Decimals(b.cantidad).toFixed(2), style: "textoTabla", alignment: "right" },
    { text: round2Decimals(b.costo).toFixed(2), style: "textoTabla", alignment: "right" },
    { text: round2Decimals(b.total).toFixed(2), style: "textoTabla", alignment: "right" },
    { text: moment(b.fecha).format("DD/MM/YYYY"), style: "textoTabla" },
  ]));

  /* =========================
     PDF DEFINITION
  ========================== */
  const dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          body: [
            [
              { image: "logo", fit: [80, 80], border: [false, false, false, false] },
              {
                border: [false, false, false, false],
                table: {
                  widths: ["100%"],
                  body: [
                    [{ text: empresa.nombreComercial || empresa.nombre, style: "tableHeader" }],
                    [{ text: `R.F.C: ${empresa.rfc}`, style: "textoChico", alignment: "center" }],
                    [{ text: "REPORTE DE COSTO TOTAL DEL PROYECTO", style: "tableHeader" }],
                  ],
                },
                layout: "noBorders",
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha de Impresión", style: "subheader", alignment: "center" }],
                    [{ text: moment().format("LL"), style: "textoChico", alignment: "center" }],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          body: filtrados,
        },
      },

      { text: "Resumen de costos", style: "subheader" },
      {
        style: "tableExample",
        table: {
          widths: ["70%", "30%"],
          body: [
            [
              { text: "Concepto", style: "tituloTabla" },
              { text: "Monto", style: "tituloTabla" },
            ],
            ...resumenTabla,
          ],
        },
      },

      { text: "Inventario dado de baja", style: "subheader" },
      {
        style: "tableExample",
        table: {
          widths: ["15%", "25%", "15%", "10%", "10%", "10%", "15%"],
          body: [
            [
              { text: "Proyecto", style: "tituloTabla" },
              { text: "Insumo", style: "tituloTabla" },
              { text: "Concepto", style: "tituloTabla" },
              { text: "Cantidad", style: "tituloTabla" },
              { text: "Costo U.", style: "tituloTabla" },
              { text: "Costo Total", style: "tituloTabla" },
              { text: "Fecha", style: "tituloTabla" },
            ],
            ...detalleTabla,
          ],
        },
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      subheader: { fontSize: 8, bold: true },
      tableHeader: { fontSize: 12, bold: true, alignment: "center" },
      textoChico: { fontSize: 8 },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        alignment: "center",
      },
      textoTabla: { fontSize: 8 },
      tableExample: { margin: [0, 5, 0, 5] },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
  };

  return dd;
};

export default reporteCostoTotalProyectoPdf;
